import { IntegrationsMapping } from "../../../../integrations/IntegrationsMapping";

export const getHostHistoryRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.crowdstrike_data?.last_seen) {
    rowsMap.push({
      id: 1,
      last_seen: entityData?.crowdstrike_data?.last_seen,
      source: IntegrationsMapping.crowdstrike.codeName,
    });
  }
  if (entityData?.jamf_data?.last_seen) {
    rowsMap.push({
      id: 2,
      last_seen: entityData?.jamf_data?.last_seen,
      source: IntegrationsMapping.jamf.codeName,
    });
  }
  if (entityData?.jamf_protect_data?.last_seen) {
    rowsMap.push({
      id: 3,
      last_seen: entityData?.jamf_protect_data?.last_seen,
      source: IntegrationsMapping.jamf_protect.codeName,
    });
  }
  if (entityData?.intune_data?.last_sync_date) {
    rowsMap.push({
      id: 4,
      last_seen: entityData?.intune_data?.last_sync_date,
      source: IntegrationsMapping.intune.codeName,
    });
  }
  if (entityData?.microsoft_entra_id_data?.last_seen) {
    rowsMap.push({
      id: 5,
      last_seen: entityData?.microsoft_entra_id_data?.last_seen,
      source: IntegrationsMapping.microsoft_entra_id.codeName,
    });
  }
  if (entityData?.zscaler_zcc_data?.last_seen_time) {
    rowsMap.push({
      id: 6,
      last_seen: entityData?.zscaler_zcc_data?.last_seen_time,
      source: IntegrationsMapping.zscaler_zcc.codeName,
    });
  }
  if (entityData?.paloalto_cortex_xdr_data?.last_seen) {
    rowsMap.push({
      id: 7,
      last_seen: entityData?.paloalto_cortex_xdr_data?.last_seen,
      source: IntegrationsMapping.paloalto_cortex_xdr.codeName,
    });
  }
  if (entityData?.microsoft_defender_data?.last_seen) {
    rowsMap.push({
      id: 8,
      last_seen: entityData?.microsoft_defender_data?.last_seen,
      source: IntegrationsMapping.microsoft_defender_endpoint.codeName,
    });
  }
  if (entityData?.microsoft_defender_data?.first_seen) {
    rowsMap.push({
      id: 8.5,
      first_seen: entityData?.microsoft_defender_data?.first_seen,
      source: IntegrationsMapping.microsoft_defender_endpoint.codeName,
    });
  }
  if (entityData?.crowdstrike_data?.first_seen)
    rowsMap.push({
      id: 9,
      first_seen: entityData?.crowdstrike_data?.first_seen,
      source: IntegrationsMapping.crowdstrike.codeName,
    });
  if (entityData?.okta_data?.creation_date)
    rowsMap.push({
      id: 10,
      first_seen: entityData?.okta_data?.creation_date,
      source: IntegrationsMapping.okta.codeName,
    });
  if (entityData?.jamf_data?.creation_date)
    rowsMap.push({
      id: 11,
      first_seen: entityData?.jamf_data?.creation_date,
      source: IntegrationsMapping.jamf.codeName,
    });
  if (entityData?.okta_data?.last_updated_date)
    rowsMap.push({
      id: 12,
      last_updated: entityData?.okta_data?.last_updated_date,
      source: IntegrationsMapping.okta.codeName,
    });
  if (entityData?.jamf_data?.last_enrolled_date)
    rowsMap.push({
      id: 13,
      last_enrollment: entityData?.jamf_data?.last_enrolled_date,
      source: IntegrationsMapping.jamf.codeName,
    });
  if (entityData?.rapid7_insight_vm_data?.last_scan_end)
    rowsMap.push({
      id: 14,
      last_scan: entityData?.rapid7_insight_vm_data?.last_scan_end,
      source: IntegrationsMapping.rapid7_insight_vm.codeName,
    });
  if (entityData?.paloalto_talon_data?.last_seen) {
    rowsMap.push({
      id: 15,
      last_seen: entityData?.paloalto_talon_data?.last_seen,
      source: IntegrationsMapping.paloalto_talon.codeName,
    });
  }
  if (entityData?.paloalto_talon_data?.first_seen) {
    rowsMap.push({
      id: 16,
      first_seen: entityData?.paloalto_talon_data?.first_seen,
      source: IntegrationsMapping.paloalto_talon.codeName,
    });
  }
  if (entityData?.paloalto_prisma_access_browser_data?.first_seen) {
    rowsMap.push({
      id: 17,
      first_seen: entityData?.paloalto_prisma_access_browser_data?.first_seen,
      source: IntegrationsMapping.paloalto_prisma_access_browser.codeName,
    });
  }
  if (entityData?.paloalto_prisma_access_browser_data?.last_seen) {
    rowsMap.push({
      id: 18,
      last_seen: entityData?.paloalto_prisma_access_browser_data?.last_seen,
      source: IntegrationsMapping.paloalto_prisma_access_browser.codeName,
    });
  }
  if (entityData?.sentinel_one_data?.last_seen) {
    rowsMap.push({
      id: 19,
      last_seen: entityData?.sentinel_one_data?.last_seen,
      source: IntegrationsMapping.sentinel_one.codeName,
    });
  }
  if (entityData?.sentinel_one_data?.last_successful_scan_date) {
    rowsMap.push({
      id: 20,
      last_scan: entityData?.sentinel_one_data?.last_successful_scan_date,
      source: IntegrationsMapping.sentinel_one.codeName,
    });
  }
  if (entityData?.sentinel_one_data?.created_at) {
    rowsMap.push({
      id: 21,
      first_seen: entityData?.sentinel_one_data?.created_at,
      source: IntegrationsMapping.sentinel_one.codeName,
    });
  }
  if (entityData?.sentinel_one_data?.last_updated_date) {
    rowsMap.push({
      id: 22,
      last_updated: entityData?.sentinel_one_data?.last_updated_date,
      source: IntegrationsMapping.sentinel_one.codeName,
    });
  }
  if (entityData?.paloalto_cortex_xdr_data?.first_seen) {
    rowsMap.push({
      id: 23,
      first_seen: entityData?.paloalto_cortex_xdr_data?.first_seen,
      source: IntegrationsMapping.paloalto_cortex_xdr.codeName,
    });
  }
  if (
    entityData?.netskope_data?.install_time ||
    entityData?.netskope_data?.last_seen
  ) {
    const historyInfo = {
      id: 24,
      source: IntegrationsMapping.netskope.codeName,
    };
    if (entityData?.netskope_data?.install_time)
      historyInfo.first_seen = entityData?.netskope_data?.install_time;
    if (entityData?.netskope_data?.last_seen)
      historyInfo.last_seen = entityData?.netskope_data?.last_seen;
    rowsMap.push(historyInfo);
  }
  if (
    entityData?.ninjaone_data?.first_seen ||
    entityData?.ninjaone_data?.last_seen
  ) {
    const historyInfo = {
      id: 25,
      source: IntegrationsMapping.ninjaone.codeName,
    };
    if (entityData?.ninjaone_data?.first_seen)
      historyInfo.first_seen = entityData?.ninjaone_data?.first_seen;
    if (entityData?.ninjaone_data?.last_seen)
      historyInfo.last_seen = entityData?.ninjaone_data?.last_seen;
    rowsMap.push(historyInfo);
  }
  if (entityData?.cloudflare_ztna_data?.last_seen_at) {
    rowsMap.push({
      id: 26,
      last_seen: entityData?.cloudflare_ztna_data?.last_seen_at,
      source: IntegrationsMapping.cloudflare.codeName,
    });
  }
  if (entityData?.cloudflare_ztna_data?.created_at) {
    rowsMap.push({
      id: 27,
      first_seen: entityData?.cloudflare_ztna_data?.created_at,
      source: IntegrationsMapping.cloudflare.codeName,
    });
  }
  if (entityData?.jumpcloud_data?.creation_date) {
    rowsMap.push({
      id: 28,
      first_seen: entityData?.jumpcloud_data?.creation_date,
      source: IntegrationsMapping.jumpcloud.codeName,
    });
  }
  if (entityData?.jumpcloud_data?.last_seen) {
    rowsMap.push({
      id: 29,
      last_seen: entityData?.jumpcloud_data?.last_seen,
      source: IntegrationsMapping.jumpcloud.codeName,
    });
  }
  if (entityData?.intune_data?.enrolled_date) {
    rowsMap.push({
      id: 30,
      last_enrollment: entityData?.intune_data?.enrolled_date,
      source: IntegrationsMapping.intune.codeName,
    });
  }
  if (entityData?.kandji_data?.last_enrolled_date) {
    rowsMap.push({
      id: 31,
      last_enrollment: entityData?.kandji_data?.last_enrolled_date,
      source: IntegrationsMapping.kandji.codeName,
    });
    rowsMap.push({
      id: 32,
      last_seen: entityData?.kandji_data?.last_seen_date,
      source: IntegrationsMapping.kandji.codeName,
    });
    rowsMap.push({
      id: 33,
      first_seen: entityData?.kandji_data?.creation_date,
      source: IntegrationsMapping.kandji.codeName,
    });
  }
  if (entityData?.addigy_data?.last_seen) {
    rowsMap.push({
      id: 34,
      last_seen: entityData?.addigy_data?.last_seen,
      source: IntegrationsMapping.addigy.codeName,
    });
  }
  if (entityData?.addigy_data?.creation_date) {
    rowsMap.push({
      id: 35,
      first_seen: entityData?.addigy_data?.creation_date,
      source: IntegrationsMapping.addigy.codeName,
    });
  }
  if (entityData?.qualys_data?.last_seen_date) {
    rowsMap.push({
      id: 36,
      last_seen: entityData?.qualys_data?.last_seen_date,
      source: IntegrationsMapping.qualys.codeName,
    });
  }
  if (entityData?.qualys_data?.creation_date) {
    rowsMap.push({
      id: 37,
      first_seen: entityData?.qualys_data?.creation_date,
      source: IntegrationsMapping.qualys.codeName,
    });
  }
  if (entityData?.qualys_data?.last_vulnerability_scan_date) {
    rowsMap.push({
      id: 38,
      last_scan: entityData?.qualys_data?.last_vulnerability_scan_date,
      source: IntegrationsMapping.qualys.codeName,
    });
  }
  if (entityData?.servicenow_cmdb_data?.last_seen) {
    rowsMap.push({
      id: 39,
      last_seen: entityData?.servicenow_cmdb_data?.last_seen,
      source: IntegrationsMapping.servicenow_cmdb.codeName,
    });
  }
  if (entityData?.servicenow_cmdb_data?.first_seen) {
    rowsMap.push({
      id: 40,
      first_seen: entityData?.servicenow_cmdb_data?.first_seen,
      source: IntegrationsMapping.servicenow_cmdb.codeName,
    });
  }
  if (entityData?.servicenow_cmdb_data?.last_updated) {
    rowsMap.push({
      id: 41,
      last_updated: entityData?.servicenow_cmdb_data?.last_updated,
      source: IntegrationsMapping.servicenow_cmdb.codeName,
    });
  }
  if (entityData?.servicenow_cmdb_data?.purchase_date) {
    rowsMap.push({
      id: 42,
      purchase_date: entityData?.servicenow_cmdb_data?.purchase_date,
      source: IntegrationsMapping.servicenow_cmdb.codeName,
    });
  }
  if (entityData?.microsoft_sccm_data?.creation_date) {
    rowsMap.push({
      id: 43,
      first_seen: entityData?.microsoft_sccm_data?.creation_date,
      source: "microsoft_sccm",
    });
  }
  if (entityData?.microsoft_sccm_data?.last_seen) {
    rowsMap.push({
      id: 44,
      last_seen: entityData?.microsoft_sccm_data?.last_seen,
      source: "microsoft_sccm",
    });
  }
  if (entityData?.microsoft_active_directory_data?.creation_date) {
    rowsMap.push({
      id: 45,
      first_seen: entityData?.microsoft_active_directory_data?.creation_date,
      source: IntegrationsMapping.microsoft_active_directory.codeName,
    });
  }
  if (entityData?.microsoft_active_directory_data?.last_logon_date) {
    rowsMap.push({
      id: 46,
      last_seen: entityData?.microsoft_active_directory_data?.last_logon_date,
      source: IntegrationsMapping.microsoft_active_directory.codeName,
    });
  }
  if (entityData?.microsoft_active_directory_data?.last_change_date) {
    rowsMap.push({
      id: 47,
      last_updated:
        entityData?.microsoft_active_directory_data?.last_change_date,
      source: IntegrationsMapping.microsoft_active_directory.codeName,
    });
  }
  if (entityData?.cato_data?.last_connected) {
    rowsMap.push({
      id: 48,
      last_seen: entityData?.cato_data?.last_connected,
      source: IntegrationsMapping.cato.codeName,
    });
  }
  return rowsMap;
};

export const hostHistoryDisabled = (entityData) => {
  return getHostHistoryRows(entityData).length <= 0;
};

export const hostHasComplianceData = (entityData) => {
  return (
    entityData?.servicenow_cmdb_data?.pci_cde != null ||
    entityData?.servicenow_cmdb_data?.pci_supporting != null ||
    entityData?.servicenow_cmdb_data?.pci_supporting_asset != null ||
    entityData?.servicenow_cmdb_data?.ccpa != null ||
    entityData?.servicenow_cmdb_data?.sox != null ||
    entityData?.servicenow_cmdb_data?.pii != null ||
    entityData?.servicenow_cmdb_data?.gdpr != null ||
    entityData?.servicenow_cmdb_data?.iso_27001 != null
  );
};

export const hostHasClassificationData = (entityData) => {
  return (
    entityData?.servicenow_cmdb_data?.crown_jewel != null ||
    entityData?.servicenow_cmdb_data?.environment ||
    entityData?.servicenow_cmdb_data?.is_global != null ||
    entityData?.servicenow_cmdb_data?.sys_class_name ||
    entityData?.servicenow_cmdb_data?.sys_tags ||
    entityData?.servicenow_cmdb_data?.application_id_tag
  );
};

export const hostHasOwnershipData = (entityData) => {
  return (
    entityData?.servicenow_cmdb_data?.owning_service_owning_organization ||
    entityData?.servicenow_cmdb_data?.owning_service_owned_by ||
    entityData?.servicenow_cmdb_data?.owning_service_managed_by ||
    entityData?.servicenow_cmdb_data?.it_application_owner ||
    entityData?.servicenow_cmdb_data?.owning_service_assignment_group ||
    entityData?.servicenow_cmdb_data?.owning_company_sys_id ||
    entityData?.servicenow_cmdb_data?.used_by_companies ||
    entityData?.servicenow_cmdb_data?.owning_service_used_by_companies
  );
};

export const getHostGroupsRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.sentinel_one_data?.group_name) {
    rowsMap.push({
      id: 1,
      group_name: entityData?.sentinel_one_data?.group_name,
      source: IntegrationsMapping.sentinel_one.codeName,
    });
  }
  if (entityData?.crowdstrike_data?.group_names) {
    for (const group of entityData?.crowdstrike_data?.group_names) {
      rowsMap.push({
        id: rowsMap.length + 1,
        group_name: group,
        source: IntegrationsMapping.crowdstrike.codeName,
      });
    }
  }
  if (entityData?.jamf_data?.group_names) {
    for (const group of entityData?.jamf_data?.group_names) {
      rowsMap.push({
        id: rowsMap.length + 1,
        group_name: group,
        source: IntegrationsMapping.jamf.codeName,
      });
    }
  }
  if (entityData?.jumpcloud_data?.groups) {
    for (const group of entityData?.jumpcloud_data?.groups) {
      rowsMap.push({
        id: rowsMap.length + 1,
        group_name: group,
        source: IntegrationsMapping.jumpcloud.codeName,
      });
    }
  }

  if (entityData?.microsoft_sccm_data?.groups) {
    for (const group of entityData?.microsoft_sccm_data?.groups) {
      rowsMap.push({
        id: rowsMap.length + 1,
        group_name: group,
        source: "microsoft_sccm",
      });
    }
  }
  if (entityData?.microsoft_defender_data?.group_name) {
    rowsMap.push({
      id: rowsMap.length + 1,
      group_name: entityData?.microsoft_defender_data?.group_name,
      source: IntegrationsMapping.microsoft_defender_endpoint.codeName,
    });
  }
  if (entityData?.microsoft_active_directory_data?.groups) {
    for (const group of entityData?.microsoft_active_directory_data?.groups) {
      rowsMap.push({
        id: rowsMap.length + 1,
        group_name: group,
        source: IntegrationsMapping.microsoft_active_directory.codeName,
      });
    }
  }
  return rowsMap;
};

export const getHostPoliciesRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.crowdstrike_data?.policies) {
    for (const policy of entityData.crowdstrike_data.policies) {
      rowsMap.push({
        id: rowsMap.length + 1,
        policy: policy,
        source: IntegrationsMapping.crowdstrike.codeName,
      });
    }
  }
  if (entityData?.jamf_data?.policies) {
    for (const policy of entityData.jamf_data.policies) {
      rowsMap.push({
        id: rowsMap.length + 1,
        policy: policy,
        source: IntegrationsMapping.jamf.codeName,
      });
    }
  }
  if (entityData?.paloalto_cortex_xdr_data?.assigned_extensions_policy) {
    rowsMap.push({
      id: rowsMap.length + 1,
      policy: entityData.paloalto_cortex_xdr_data.assigned_extensions_policy,
      source: IntegrationsMapping.paloalto_cortex_xdr.codeName,
      type: "Extension",
    });
  }
  if (entityData?.paloalto_cortex_xdr_data?.assigned_prevention_policy) {
    rowsMap.push({
      id: rowsMap.length + 1,
      policy: entityData.paloalto_cortex_xdr_data.assigned_prevention_policy,
      source: IntegrationsMapping.paloalto_cortex_xdr.codeName,
      type: "Prevention",
    });
  }
  return rowsMap;
};

export const hostHasSecurityGroups = (entityData) => {
  return entityData?.microsoft_sccm_data?.security_groups?.length > 0;
};

export const hostHasInstalledPrograms = (entityData) => {
  return entityData?.has_installed_programs ?? false;
};

export const hostHasTags = (entityData) => {
  if (
    entityData?.kandji_data?.tags?.length > 0 ||
    entityData?.qualys_data?.tags?.length > 0 ||
    entityData?.microsoft_defender_data?.machine_tags?.length > 0
  ) {
    return true;
  } else {
    return false;
  }
};

export const getHostLoginsRows = (entityData) => {
  let rowsMap = [];

  const recentLogins = entityData?.crowdstrike_data?.recent_logins_compressed;
  if (recentLogins) {
    for (const login of recentLogins) {
      rowsMap.push({
        id: login.id || rowsMap.length + 1,
        account_name: login.account_name,
        login_timestamp: login.login_timestamp,
        login_type: login.login_type,
        login_status: login.login_status,
        is_admin: login.local_admin_privileges || "No",
        source: IntegrationsMapping.crowdstrike.codeName,
      });
    }
  }

  return rowsMap;
};
